import { render, staticRenderFns } from "./svg-icon-tg.vue?vue&type=template&id=435ce1d6&"
import script from "./svg-icon-tg.vue?vue&type=script&lang=js&"
export * from "./svg-icon-tg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('435ce1d6')) {
      api.createRecord('435ce1d6', component.options)
    } else {
      api.reload('435ce1d6', component.options)
    }
    module.hot.accept("./svg-icon-tg.vue?vue&type=template&id=435ce1d6&", function () {
      api.rerender('435ce1d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/svg-icon-tg.vue"
export default component.exports